<button *ngIf="showBack" mat-icon-button matTooltip="Go back" (click)="back()"><mat-icon>arrow_back</mat-icon></button>
<button *ngIf="showForward" mat-icon-button matTooltip="Go forward" (click)="forward()"><mat-icon>arrow_forward</mat-icon></button>
